import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import payment_complete from "../../assets/images/payment_complete.png";

const PaymentComplete = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/programpage");
    }, 5000); //redirect after 5 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-[#101218]">
      <div
        className="md:mx-32 mx-6 mt-10 mb-20 py-20 border-2px border-[#232D38] rounded-lg"
        style={{
          background:
            "linear-gradient(0deg, #222631, #222631),linear-gradient(0deg, #232D38, #232D38",
        }}
      >
        <div className="flex flex-col space-y-6 justify-center items-center">
          <img src={payment_complete} alt="registration Complete" />
          <p className="md:text-4xl text-2xl font-bold font-poppins text-[#C3F73A]">
            Payment Complete!
          </p>
          <p className="text-white font-poppins text-sm md:pt-36 pt-20 ">
            Redirecting you to Homepage...
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentComplete;
